export { CustomerNameAndLogoHeader } from './src';
